import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../global/utils';
import Config from '../../global/config';
// Thunk to fetch all cities
export const getallCities = createAsyncThunk(
  'cities/getallCities',
  async () => {
    try {
      const response = await apiRequest('GET', 'admin/cities/list',null,Config.Key);
      // console.log(response);
      return response.data; // Return the API response data
    } catch (error) {
      // console.log(error);
    }
  }
);
export const getCurrentLocation = createAsyncThunk(
  'cities/getCurrentLocation',
  async (_, thunkAPI) => {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
        });
      });

      const req= position.coords;
      // console.log(req.latitude);
      // console.log(req.longitude);
      const lat=req.latitude;
      const lon=req.longitude;
 
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`)
// console.log(res);
      const data = await res.json();

      const cityName = data?.address?.city || data?.address?.town || data?.address?.village || "";

      // Optional matching with existing cities
      const state = thunkAPI.getState();
      const allCities = state.cities.cities || [];
      const match = allCities.find(
        (city) => city.name.toLowerCase() === cityName.toLowerCase()
      );

      return {
        city: cityName,
        basePrice: match ? match.basePrice || 5.95 : 0,  // You can adjust logic
      };
    } catch (error) {
      // console.log("Error getting location:", error);
      return thunkAPI.rejectWithValue("Unable to fetch location");
    }
  }
);
;


const citiesSlice = createSlice({
  name: 'cities',
  initialState: {
    cities: [],
    status: 'idle',
    error: null,
    createCityStatus: 'idle',
    createCityError: null,
   currentLocation: {
      city: '',
      basePrice: 0,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch all cities
      .addCase(getallCities.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getallCities.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.cities = action.payload?.cities?.content || action.payload || [];
      })
      .addCase(getallCities.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
       .addCase(getCurrentLocation.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
   .addCase(getCurrentLocation.fulfilled, (state, action) => {
  state.status = 'succeeded';
  state.currentLocation = action.payload; // expects an object like { city: 'Austin', basePrice: 5.95 }
})

      .addCase(getCurrentLocation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      
      
  },
});

export default citiesSlice.reducer;